// extracted by mini-css-extract-plugin
export var cardTitle = "_if-1";
export var commentBubble = "_if-e";
export var commentForm = "_if-a";
export var commentInput = "_if-b";
export var commentLabel = "_if-d";
export var commentPrompt = "_if-9";
export var csatCard = "_if-0";
export var feedbackSection = "_if-7";
export var starDisabled = "_if-6";
export var starEmpty = "_if-5";
export var starFilled = "_if-4";
export var starWrapper = "_if-3";
export var starsContainer = "_if-2";
export var submittedComment = "_if-c";
export var thankYouText = "_if-8";